var React = require('react');

function IcArrowComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-arrow forward"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M3.33333 9.66688V9.66689L13.4792 9.66688H3.33333ZM8.81251 16.0002L13.4792 11.3336L8.8125 16.0002L8.81251 16.0002ZM9.16763 15.9987L14.0827 11.0836H3.58333V9.91689H14.0827L9.16763 5.00179L9.99844 4.18555L16.3131 10.5002L9.99844 16.8149L9.16763 15.9987Z","fill":"#BABABA"})));
}

IcArrowComponent.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = IcArrowComponent;

IcArrowComponent.default = IcArrowComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/JoinTariffModalV2/images/ic-arrow.component.svg
// module id = 708
// module chunks = 0